import { hrmsGet, hrmsPost } from "../api/api";


/**
 * GET /saas/hrms/weekly_work_schedule/all
 * Returns the flat rows as stored: { dayOfWeek, dayType, weekNumber }.
 */
export async function fetchWeeklyWorkSchedule() {
  const response = await hrmsGet("/weekly_work_schedule/all", "HR27S");
  return response?.data ?? [];
}

/**
 * POST /saas/hrms/weekly_work_schedule/add
 * Replaces the tenant's entire weekly work schedule in one call —
 * the backend deletes all existing rows and inserts the given list.
 */
export async function saveWeeklyWorkSchedule(rows) {
  const payload = rows.map((row) => ({
    dayOfWeek: row.dayOfWeek,
    dayType: row.dayType,
    weekNumber: String(row.weekNumber),
  }));

  return hrmsPost("/weekly_work_schedule/add", payload, "HR27A");
}